import React from 'react';
import { heroContent, galleryImages } from '../data/mock';

const HeroSection = () => {
  // Get the makeup application image for hero
  const heroImage = galleryImages.find((img) => img.category === 'hero');

  return (
    <section id="inicio" className="min-h-screen flex items-center bg-[#fffef2] pt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1 animate-fade-in">
            {heroContent.subtitle && (
              <p className="hero-subtitle text-[#666] mb-4">
                {heroContent.subtitle}
              </p>
            )}
            <h1 className="font-display lg:text-6xl !font-light !text-5xl !tracking-[0.1em] mb-6 text-[#333]">
              {heroContent.title}
            </h1>
            <p className="body-large text-[#666] max-w-lg">
              {heroContent.description}
            </p>
          </div>

          {/* Image - object-top para mostrar más la parte de arriba */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={heroImage?.src}
                  alt="Luciana Belén - Maquillaje profesional"
                  className="w-full h-full object-cover object-top img-hover"
                />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-[#bcbbb4] -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;